import { Result } from '../../../@types/PolicyHolderDetails'
import { UpdateEntityDetailsClientRequest } from '../../../@types/UpdateEntityDetails'
import { usePolicyholderDetailsStore } from '../../../Stores/policyholderDetailsStore'
import { ID_EXTERNAL_TYPES } from '../../../constants/idExternalTypes'

export const useIdentificationUpdateEntityPayload = () => {
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()

  const handleIdentificationPayload = (newJob: Result) => {
    const payload: UpdateEntityDetailsClientRequest = {
      idEntity: policyholderDetailsSelected?.idEntity || '',
      entityType: 'Individual', // TODO: hardcoded
      idExternalType: ID_EXTERNAL_TYPES.globalEntity || '',
      jobDescription: newJob?.description || '',
      job: newJob?.idElement || '',
      countryCode:
        policyholderDetailsSelected?.addresses?.[0]?.countryCode || '',
    }

    return payload
  }

  return {
    handleIdentificationPayload,
  }
}
